/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import { arrow, flip, offset, shift, useFloating } from "@floating-ui/react";
import { Tooltip, tooltipPlacement } from "@visiblethread/react-components";
import PropTypes from "prop-types";
import { useRef, useState } from "react";
import { createPortal } from "react-dom";

const Ellipsis = ({
  text,
  tooltip,
  classes = "",
  style = {},
  placement = tooltipPlacement.bottom,
  tooltipMaxWidth = "200px",
  tooltipMaxHeight,
  "data-clarity-mask": dataClarityMask,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const spanRef = useRef(null);
  const arrowRef = useRef(null);

  const { refs, floatingStyles, context } = useFloating({
    placement,
    open: showTooltip,
    onOpenChange: setShowTooltip,
    middleware: [
      offset(8),
      arrow({ element: arrowRef }),
      flip(),
      shift({ padding: 0 }),
    ],
  });

  const handleMouseOver = (event) => {
    const target = event.currentTarget;
    const parent = target.parentElement;

    if (
      target.offsetWidth < target.scrollWidth ||
      (parent && parent.offsetWidth < parent.scrollWidth)
    ) {
      refs.setReference(target);
      setShowTooltip(true);
    } else {
      setShowTooltip(false);
    }
  };

  const handleMouseOut = () => {
    setShowTooltip(false);
  };

  return (
    <div className="ellipsis_text__wrapper">
      <span
        className={`ellipsis_text ${classes}`}
        style={style}
        ref={spanRef}
        data-testid="ellipsis"
        data-clarity-mask={dataClarityMask}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      >
        {text}
        {showTooltip &&
          createPortal(
            <Tooltip
              ref={refs.setFloating}
              content={tooltip || text}
              placement={placement}
              style={{
                ...floatingStyles,
                maxWidth: tooltipMaxWidth,
                maxHeight: tooltipMaxHeight,
              }}
              arrowRef={arrowRef}
              context={context}
            />,
            document.body
          )}
      </span>
    </div>
  );
};

export default Ellipsis;

Ellipsis.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.array,
    PropTypes.number,
  ]).isRequired,
  tooltip: PropTypes.string,
  classes: PropTypes.string,
  style: PropTypes.object,
  placement: PropTypes.string,
  tooltipMaxWidth: PropTypes.number,
  tooltipMaxHeight: PropTypes.number,
  "data-clarity-mask": PropTypes.string,
};
